(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
'use strict';

var _utils = require('./utils');

var _jsCookie = require('js-cookie');

var _jsCookie2 = _interopRequireDefault(_jsCookie);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

$(function () {

	// Underline style

	$('.underline').each(function () {

		var words = $(this).text().split(' ');

		$(this).empty().html(function () {

			var i = 0;

			for (i = 0; i < words.length; i++) {
				if (i == 0) {
					$(this).append('<span>' + words[i] + '</span>');
				} else {
					$(this).append(' <span>' + words[i] + '</span>');
				}
			}
		});
	});

	if (_utils.isMobile.any()) {
		// Close collapsible main-menu after click
		$('#main-menu > ul > li > a').on('click', function () {
			return $('#main-menu-collapse-button').click();
		});
	}

	// About page scroller

	// if ($('body').hasClass('about')) {
	//
	// 	// Skrollr
	// 	var skroll = skrollr.init({
	// 		forceHeight: false
	// 	})
	//
	// 	// Skrollr menu
	// 	skrollr.menu.init(skroll, {
	// 			animate: true,
	// 			easing: 'swing',
	// 			scale: 2,
	// 			duration: function(currentTop, targetTop) {
	// 					Math.abs(targetTop - currentTop) / 4;
	// 			}
	// 	})
	//
	// 	onWindowResize()
	// 	$(window).resize(onWindowResize)
	// }
	//
	// function onWindowResize () {
	// 	skroll.refresh()
	// }

	// Public vote on project

	function csrfSafeMethod(method) {
		return (/^(GET|HEAD|OPTIONS|TRACE)$/.test(method)
		);
	}

	$.ajaxSetup({
		beforeSend: function beforeSend(xhr, settings) {
			if (!csrfSafeMethod(settings.type) && !this.crossDomain) {
				xhr.setRequestHeader("X-CSRFToken", _jsCookie2.default.get('csrftoken'));
			}
		}
	});

	$('.public-vote').on('click', function () {
		$.ajax({
			url: './vote/',
			method: 'POST'
		});
		$(this).text('Thanks for your vote!').addClass('voted');
		$(this).off();
	});
});

// Sticky elements

// On homepage

var fixedSidebarTopOffset = -85;
var fixedSidebarBottomOffset = 15;

var controller = new ScrollMagic.Controller();

var scene1 = new ScrollMagic.Scene({
	triggerElement: '#section__label--latest',
	triggerHook: 'onLeave',
	offset: fixedSidebarTopOffset,
	duration: $('#section-latest').height() - $('#section__label--latest').height() - fixedSidebarBottomOffset
});

scene1.setClassToggle('#section__label--latest', 'fixed').setPin('#section__label--latest').addTo(controller);

var scene2 = new ScrollMagic.Scene({
	triggerElement: '#section__label--news',
	triggerHook: 'onLeave',
	offset: fixedSidebarTopOffset,
	duration: $('#section-news').height() - $('#section__label--news').height() - fixedSidebarBottomOffset
});

scene2.setClassToggle('#section__label--news', 'fixed').setPin('#section__label--news').addTo(controller);

var scene3 = new ScrollMagic.Scene({
	triggerElement: '#section__label--events',
	triggerHook: 'onLeave',
	offset: fixedSidebarTopOffset,
	duration: $('#section-events').height() - $('#section__label--events').height() - fixedSidebarBottomOffset
});

scene3.setClassToggle('#section__label--events', 'fixed').setPin('#section__label--events').addTo(controller);

var scene4 = new ScrollMagic.Scene({
	triggerElement: '#section__label--ideas',
	triggerHook: 'onLeave',
	offset: fixedSidebarTopOffset,
	duration: $('#section-ideas').height() - $('#section__label--ideas').height() - fixedSidebarBottomOffset
});

scene4.setClassToggle('#section__label--ideas', 'fixed').setPin('#section__label--ideas').addTo(controller);

var scene4 = new ScrollMagic.Scene({
	triggerElement: '#section__label--video',
	triggerHook: 'onLeave',
	offset: fixedSidebarTopOffset,
	duration: $('#section-video').height() - $('#section__label--video').height() - fixedSidebarBottomOffset
});

scene4.setClassToggle('#section__label--video', 'fixed').setPin('#section__label--video').addTo(controller);

var scene5 = new ScrollMagic.Scene({
	triggerElement: '#section__label--open-call',
	triggerHook: 'onLeave',
	offset: fixedSidebarTopOffset,
	duration: $('#section-open-call').height() - $('#section__label--open-call').height() - fixedSidebarBottomOffset
});

scene5.setClassToggle('#section__label--open-call', 'fixed').setPin('#section__label--open-call').addTo(controller);

// On inside pages

var scene = new ScrollMagic.Scene({
	triggerElement: '#pined-sidebar',
	triggerHook: 'onLeave',
	offset: fixedSidebarTopOffset + 5,
	duration: $('#with-pined-sidebar').height() - $('#pined-sidebar').height() - fixedSidebarBottomOffset
});

scene.setClassToggle('#pined-sidebar', 'fixed').setPin('#pined-sidebar').addTo(controller);

// Slide search
$('.search-toggler').click(function () {
	$('#searchSlide').toggleClass('search-slide-open');
	$(this).toggleClass('search-toggler--close');
});

},{"./utils":2,"js-cookie":3}],2:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
var isMobile = exports.isMobile = {
    Android: function Android() {
        return navigator.userAgent.match(/Android/i);
    },
    BlackBerry: function BlackBerry() {
        return navigator.userAgent.match(/BlackBerry/i);
    },
    iOS: function iOS() {
        return navigator.userAgent.match(/iPhone|iPad|iPod/i);
    },
    Opera: function Opera() {
        return navigator.userAgent.match(/Opera Mini/i);
    },
    Windows: function Windows() {
        return navigator.userAgent.match(/IEMobile/i);
    },
    any: function any() {
        return isMobile.Android() || isMobile.BlackBerry() || isMobile.iOS() || isMobile.Opera() || isMobile.Windows();
    }
};

},{}],3:[function(require,module,exports){
/*!
 * JavaScript Cookie v2.2.0
 * https://github.com/js-cookie/js-cookie
 *
 * Copyright 2006, 2015 Klaus Hartl & Fagner Brack
 * Released under the MIT license
 */
;(function (factory) {
	var registeredInModuleLoader = false;
	if (typeof define === 'function' && define.amd) {
		define(factory);
		registeredInModuleLoader = true;
	}
	if (typeof exports === 'object') {
		module.exports = factory();
		registeredInModuleLoader = true;
	}
	if (!registeredInModuleLoader) {
		var OldCookies = window.Cookies;
		var api = window.Cookies = factory();
		api.noConflict = function () {
			window.Cookies = OldCookies;
			return api;
		};
	}
}(function () {
	function extend () {
		var i = 0;
		var result = {};
		for (; i < arguments.length; i++) {
			var attributes = arguments[ i ];
			for (var key in attributes) {
				result[key] = attributes[key];
			}
		}
		return result;
	}

	function init (converter) {
		function api (key, value, attributes) {
			var result;
			if (typeof document === 'undefined') {
				return;
			}

			// Write

			if (arguments.length > 1) {
				attributes = extend({
					path: '/'
				}, api.defaults, attributes);

				if (typeof attributes.expires === 'number') {
					var expires = new Date();
					expires.setMilliseconds(expires.getMilliseconds() + attributes.expires * 864e+5);
					attributes.expires = expires;
				}

				// We're using "expires" because "max-age" is not supported by IE
				attributes.expires = attributes.expires ? attributes.expires.toUTCString() : '';

				try {
					result = JSON.stringify(value);
					if (/^[\{\[]/.test(result)) {
						value = result;
					}
				} catch (e) {}

				if (!converter.write) {
					value = encodeURIComponent(String(value))
						.replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);
				} else {
					value = converter.write(value, key);
				}

				key = encodeURIComponent(String(key));
				key = key.replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent);
				key = key.replace(/[\(\)]/g, escape);

				var stringifiedAttributes = '';

				for (var attributeName in attributes) {
					if (!attributes[attributeName]) {
						continue;
					}
					stringifiedAttributes += '; ' + attributeName;
					if (attributes[attributeName] === true) {
						continue;
					}
					stringifiedAttributes += '=' + attributes[attributeName];
				}
				return (document.cookie = key + '=' + value + stringifiedAttributes);
			}

			// Read

			if (!key) {
				result = {};
			}

			// To prevent the for loop in the first place assign an empty array
			// in case there are no cookies at all. Also prevents odd result when
			// calling "get()"
			var cookies = document.cookie ? document.cookie.split('; ') : [];
			var rdecode = /(%[0-9A-Z]{2})+/g;
			var i = 0;

			for (; i < cookies.length; i++) {
				var parts = cookies[i].split('=');
				var cookie = parts.slice(1).join('=');

				if (!this.json && cookie.charAt(0) === '"') {
					cookie = cookie.slice(1, -1);
				}

				try {
					var name = parts[0].replace(rdecode, decodeURIComponent);
					cookie = converter.read ?
						converter.read(cookie, name) : converter(cookie, name) ||
						cookie.replace(rdecode, decodeURIComponent);

					if (this.json) {
						try {
							cookie = JSON.parse(cookie);
						} catch (e) {}
					}

					if (key === name) {
						result = cookie;
						break;
					}

					if (!key) {
						result[name] = cookie;
					}
				} catch (e) {}
			}

			return result;
		}

		api.set = api;
		api.get = function (key) {
			return api.call(api, key);
		};
		api.getJSON = function () {
			return api.apply({
				json: true
			}, [].slice.call(arguments));
		};
		api.defaults = {};

		api.remove = function (key, attributes) {
			api(key, '', extend(attributes, {
				expires: -1
			}));
		};

		api.withConverter = init;

		return api;
	}

	return init(function () {});
}));

},{}]},{},[1])

